import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

const markdownComponents = {
  a: ({ node, children, ...props }) => (
    <a
      {...props}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-400 hover:text-blue-300 underline break-all"
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </a>
  ),
  p: ({ node, ...props }) => (
    <p {...props} className="whitespace-pre-wrap mb-2 last:mb-0" />
  ),
  ul: ({ node, ...props }) => (
    <ul {...props} className="list-disc ml-5 mb-2 last:mb-0" />
  ),
  ol: ({ node, ...props }) => (
    <ol {...props} className="list-decimal ml-5 mb-2 last:mb-0" />
  ),
  li: ({ node, ...props }) => <li {...props} className="mb-1 last:mb-0" />,
};

const FormattedDescription = ({ text, className = "" }) => {
  if (!text) return null;

  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={markdownComponents}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export default FormattedDescription;
